module.exports = __webpack_public_path__ + "img/sb3.92d8d290.gif";